import { motion } from "framer-motion";
import { Asterisk } from "lucide-react";
import { EASE } from "./shared";
import { useLang } from "./i18n";

export function BrandBand() {
  const { lang, images } = useLang();
  return (
    <section data-testid="brand-band" className="border-y border-navy/10 bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.94, y: 24 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="flex flex-col items-center"
        >
          <div className="mb-10 flex items-center gap-4" aria-hidden="true">
            <span className="h-px w-16 bg-navy/15 md:w-28" />
            <Asterisk size={18} className="text-maple" />
            <span className="h-px w-16 bg-navy/15 md:w-28" />
          </div>
          <img
            src={images.logoFull}
            alt="Settld — AI-Powered Digital Closing Platform | Canada"
            className="w-full max-w-[560px]"
            key={lang}
          />
        </motion.div>
      </div>
    </section>
  );
}
